import React from 'react';

const ConfirmModal = ({ isOpen, onClose, onConfirm, title, message, confirmText, confirmColor }) => {
    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-gray-900/60 backdrop-blur-sm animate-in fade-in duration-200">
            {/* Modal Box */}
            <div className="bg-white rounded-3xl shadow-2xl w-full max-w-md overflow-hidden animate-in zoom-in-95 duration-200">
                
                {/* Header */}
                <div className="p-6 pb-4">
                    <h3 className="text-2xl font-black text-gray-900 tracking-tight">{title}</h3>
                    <p className="text-gray-500 font-medium mt-2 leading-relaxed">
                        {message}
                    </p>
                </div>

                {/* Footer / Buttons */}
                <div className="p-6 pt-4 bg-gray-50 border-t border-gray-100 flex justify-end space-x-3">
                    <button 
                        onClick={onClose}
                        className="px-5 py-2.5 rounded-xl font-bold text-gray-600 bg-white border border-gray-200 hover:bg-gray-100 transition-all active:scale-95"
                    >
                        Cancel
                    </button>
                    <button 
                        onClick={() => {
                            onConfirm();
                            onClose();
                        }}
                        className={`px-5 py-2.5 rounded-xl font-bold text-white shadow-md transition-all active:scale-95 ${confirmColor || 'bg-blue-600 hover:bg-blue-700'}`}
                    >
                        {confirmText || 'Confirm'}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ConfirmModal;